export default __webpack_public_path__ + "static/media/userImage.9809ef91.svg";